const ACRONYMS = new Set(['ci', 'cd', 'cicd', 'sdk', 'ml', 'llm', 'adr', 'c4', 'ux', 'ui', 'api']);

/** "security-review" → "Security Review"; keeps known acronyms upper-cased. */
export function humanTitle(slugish: string): string {
  return slugish
    .replace(/[-_]+/g, ' ')
    .trim()
    .split(' ')
    .map((w) => (ACRONYMS.has(w.toLowerCase()) ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1)))
    .join(' ');
}
